// extracted by mini-css-extract-plugin
export var actionButton = "meal-card-module--action-button--cae50";
export var actions = "meal-card-module--actions--bca10";
export var card = "meal-card-module--card--6cd1e";
export var change = "meal-card-module--change--5658e";
export var copy = "meal-card-module--copy--94cd2";
export var delBtn = "meal-card-module--del-btn--b835f";
export var labels = "meal-card-module--labels--450bf";
export var move = "meal-card-module--move--63a1e";
export var nameText = "meal-card-module--name-text--f1324";
export var preview = "meal-card-module--preview--dd8d0";
export var yourRecipeLabel = "meal-card-module--your-recipe-label--cfe72";